export enum EnumTpServicoPedido {
    Interno = 0,
    Polling = 1,
    GetPedido = 2,
    WebHook  = 3
}